/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BusinessCategory,
    BusinessCategoryFromJSON,
    BusinessCategoryFromJSONTyped,
    BusinessCategoryToJSON,
} from './BusinessCategory';
import {
    GetBusinessCategoiesResponseAllOf,
    GetBusinessCategoiesResponseAllOfFromJSON,
    GetBusinessCategoiesResponseAllOfFromJSONTyped,
    GetBusinessCategoiesResponseAllOfToJSON,
} from './GetBusinessCategoiesResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetBusinessCategoiesResponse
 */
export interface GetBusinessCategoiesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetBusinessCategoiesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetBusinessCategoiesResponse
     */
    message: string;
    /**
     * 
     * @type {Array<BusinessCategory>}
     * @memberof GetBusinessCategoiesResponse
     */
    data: Array<BusinessCategory>;
}

export function GetBusinessCategoiesResponseFromJSON(json: any): GetBusinessCategoiesResponse {
    return GetBusinessCategoiesResponseFromJSONTyped(json, false);
}

export function GetBusinessCategoiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBusinessCategoiesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(BusinessCategoryFromJSON)),
    };
}

export function GetBusinessCategoiesResponseToJSON(value?: GetBusinessCategoiesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(BusinessCategoryToJSON)),
    };
}

